import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {clientsUnitsStore} from '@store/clients/units/clients-units.store';

export const getClientsUnitsDataSource = createRequestDataSource({
  store: clientsUnitsStore,
  data$: () => clientsUnitsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getClientsUnits',
  dataKey: 'clientsUnits',
});

export const putClientUnitFacturationModeDataSource = createRequestDataSource({
  store: clientsUnitsStore,
  data$: () => clientsUnitsStore,
  requestKey: 'putClientUnitFacturationMode',
  dataKey: 'clientUnit',
});
